import { useSalonStore } from "@/lib/store/salon";
import { cn } from "@/lib/utils";

interface PriceDisplayProps {
  amount: number;
  className?: string;
  currency?: string; // Optional override for currency
}

interface PriceRangeDisplayProps {
  minPriceInCents: number;
  maxPriceInCents: number;
  className?: string;
  currency?: string; // Optional override for currency
}

/**
 * Display price using salon's currency or provided override
 */
export function PriceDisplay({ amount, className, currency }: PriceDisplayProps) {
  const { currentSalon } = useSalonStore();

  // Use provided currency or fall back to salon currency, then USD as final fallback
  const displayCurrency = currency || currentSalon?.currency || "USD";

  const price = amount / 100;
  const formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: displayCurrency,
  }).format(price);

  return <span className={cn(className)}>{formattedPrice}</span>;
}

/**
 * Display price range using salon's currency or provided override
 */
export function PriceRangeDisplay({
  minPriceInCents,
  maxPriceInCents,
  className,
  currency,
}: PriceRangeDisplayProps) {
  if (minPriceInCents === maxPriceInCents) {
    return <PriceDisplay amount={minPriceInCents} className={className} currency={currency} />;
  }

  return (
    <span className={cn(className)}>
      <PriceDisplay amount={minPriceInCents} currency={currency} /> -{" "}
      <PriceDisplay amount={maxPriceInCents} currency={currency} />
    </span>
  );
}
